<script lang="ts">
  import { setContext } from 'svelte';
  import clsx from 'clsx';
  import { paddings } from '@athena-lib/spacing';
  import { ArrowBack, ArrowForward } from '@athena-lib/Icons';
  import { contextKey, type CarouselContext, type CarouselProps } from './types';
  let scrollList: HTMLOListElement | undefined = $state(undefined);

  const {
    children,
    itemCount,
    class: className,
    peekNext = true,
    action = () => undefined,
    actionArg,
    useButtons = false,
    onChange,
  }: CarouselProps = $props();
  let activeIndex = $state(0);

  const context: CarouselContext = {
    peekNext: () => peekNext,
  };
  setContext(contextKey, context);

  let timer: ReturnType<typeof setTimeout> | undefined = undefined;
  function onScroll() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      let idx = 0;
      const containerRect = scrollList!.getBoundingClientRect();

      for (const item of scrollList!.children) {
        const itemRect = item.getBoundingClientRect();
        const leftDiff = containerRect.left - itemRect.left;
        const rightDiff = containerRect.right - itemRect.right;

        if (leftDiff < 20 && rightDiff >= 0 && rightDiff < containerRect.right / 2) {
          activeIndex = idx;
        }
        idx++;
      }
    }, 50);
  }

  function scrollTo(idx: number) {
    const children = Array.from(scrollList!.children);
    const childToScrollTo = children[idx];
    const childToScrollToRect = childToScrollTo.getBoundingClientRect();

    if (onChange) {
      onChange(activeIndex);
    }
    scrollList!.scrollTo({ left: childToScrollToRect.width * idx });
  }

  function elementAction(node: HTMLDivElement) {
    scrollList!.addEventListener('scroll', onScroll);
    if (action) {
      return action(node, actionArg!);
    }
  }

  function next() {
    activeIndex = (activeIndex + 1) % itemCount;
    scrollTo(activeIndex);
  }

  function prev() {
    activeIndex = (activeIndex - 1) % itemCount;
    scrollTo(activeIndex);
  }
</script>

<div use:elementAction class="group relative">
  <ol
    bind:this={scrollList}
    class={clsx(
      className,
      'flex snap-x snap-mandatory overflow-x-scroll scroll-smooth scrollbar-none',
    )}
    aria-label="Carousel"
  >
    {@render children()}
  </ol>
  {#if useButtons}
    <button
      type="button"
      onclick={prev}
      class="absolute left-8 top-1/2 -translate-y-1/2 rounded-full bg-black/50 text-st-white transition-opacity duration-300 group-hover:opacity-100 lg:opacity-0"
    >
      <ArrowBack sizeClass={'w-8 h-8'}></ArrowBack>
    </button>
    <button
      type="button"
      onclick={next}
      class="absolute right-8 top-1/2 -translate-y-1/2 rounded-full bg-black/50 text-st-white transition-opacity duration-300 group-hover:opacity-100 lg:opacity-0"
    >
      <ArrowForward sizeClass={'w-8 h-8'}></ArrowForward>
    </button>
  {/if}
  <!-- {/if} -->
  <ol class="flex justify-center">
    {#each Array.from({ length: itemCount }) as _, i}
      <li>
        <!-- svelte-ignore a11y_consider_explicit_label -->
        <button type="button" class={clsx(paddings.small)} onclick={() => scrollTo(i)}>
          <span
            class={clsx(
              activeIndex !== i ? 'bg-st-gray-400' : 'bg-st-gray-700',
              'inline-block h-3 w-3 rounded-full',
            )}
          >
          </span>
        </button>
      </li>
    {/each}
  </ol>
</div>
